import { IBasketOrderItem, IBasketOrderItemPrice, IBasketOrderItemColor } from "../order/types";

export default class BasketOrderItem implements IBasketOrderItem {

  id: number;
  type: string;
  name: string;
  price: IBasketOrderItemPrice | null;
  checkoutPrice: IBasketOrderItemPrice | null;
  quantity?: number;
  minConfigurationItemNumber?: number;
  color?: IBasketOrderItemColor;
  imagePath?: string;
  inBundle?: boolean;
  policyId?: number;
  manufacturer?: string;
  model?: string;
  internet?: number;
  availableColors?: IBasketOrderItemColor[];
  productColorsImages?: any[];
  colorChangeInProgress?: boolean;
  deletionInProgres?: boolean;

  constructor(
    id: number,
    type: string,
    name: string,
    price: IBasketOrderItemPrice | null,
    checkoutPrice: IBasketOrderItemPrice | null,
    quantity?: number,
    minConfigurationItemNumber?: number,
    color?: IBasketOrderItemColor,
    imagePath?: string,
    inBundle?: boolean,
    policyId?: number,
    manufacturer?: string,
    model?: string,
    internet?: number,
    availableColors?: IBasketOrderItemColor[],
    productColorsImages?: any[],
  ) {
    this.type = type;
    this.name = name;
    this.price = price;
    this.checkoutPrice = checkoutPrice;
    this.quantity = quantity;
    this.minConfigurationItemNumber = minConfigurationItemNumber;
    this.color = color;
    this.imagePath = imagePath;
    this.inBundle = inBundle;
    this.policyId = policyId;
    this.manufacturer = manufacturer;
    this.model = model;
    this.internet = internet;
    this.availableColors = availableColors;
    this.productColorsImages = productColorsImages;
    this.id = id;
  }

}
